import { Checkbox } from '../Checkbox/Checkbox';
import type { CheckboxProps } from '../Checkbox/Checkbox.types';
import { FormField } from '../FormField/FormField';
import {} from '../FormField/FormField.types';
import type { FormFieldToggleBaseProps } from '../FormField/FormField.types';
import { LabeledControl } from '../LabeledControl/LabeledControl';

export type CheckboxFieldProps = CheckboxProps & FormFieldToggleBaseProps;

export const CheckboxField = (props: CheckboxFieldProps) => {
  const {
    className,
    description,
    disabled,
    helperText,
    label,
    labelTooltip,
    error,
    hasError,
    innerRef,
    ...restProps
  } = props;
  return (
    <FormField
      {...restProps}
      className={className}
      label={label}
      labelTooltip={labelTooltip}
      error={error}
      disabled={disabled}
    >
      <LabeledControl
        {...restProps}
        control={
          <Checkbox
            {...restProps}
            hasError={hasError || error !== undefined}
            disabled={disabled}
            innerRef={innerRef}
          />
        }
        description={description}
        disabled={disabled}
        helperText={helperText}
      />
    </FormField>
  );
};
